import Pagination from './Pagination'

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js